export * from "./getters.js";
export * from "./actions.js";
export * from "./mutations";

export const STARASSIGNMENT_M = "STARASSIGNMENT/";